// import { useState } from "react";
// import { Dialog, Popover } from "@headlessui/react";
// import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
// import { NavLink } from "react-router-dom";
// import { FaCircleArrowLeft } from "react-icons/fa6";
import { FaArrowCircleLeft } from "react-icons/fa";
import { kpsiajLogoBig } from "../assets";

export default function Navbar({ menu }) {
  // const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white p-3 flex items-center shadow-custom shadow-grey relative">
      <button
        className="btn btn-brown !shadow-[0_2px_7px_0_darkgrey] absolute max-md:!hidden"
        onClick={() => (window.location.href = "https://kpsiaj.org/")}
      >
        <FaArrowCircleLeft />
        Back to website
      </button>
      <img src={kpsiajLogoBig} className="mx-auto" alt="kpsiaj-logo-big" />
    </header>
  );

  // return (
  //   <header className="bg-white shadow-custom shadow-grey">
  //     <nav
  //       className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3 lg:px-8"
  //       aria-label="Global"
  //     >
  //       <div className="flex lg:flex-1">
  //         <a href="#" className="-m-1.5 p-1.5">
  //           <span className="sr-only">KPSIAJ</span>
  //           <img className="h-16 w-auto" src={kpsiajLogo} alt="kpsiaj-logo" />
  //         </a>
  //       </div>
  //       <div className="flex lg:hidden">
  //         <button
  //           type="button"
  //           className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
  //           onClick={() => setMobileMenuOpen(true)}
  //         >
  //           <span className="sr-only">Open main menu</span>
  //           <Bars3Icon className="h-7 w-7" aria-hidden="true" />
  //         </button>
  //       </div>
  //       <Popover.Group className="hidden lg:flex lg:gap-x-5">
  //         {menu.map(({ path, name }, ind) => (
  //           <NavLink
  //             key={ind}
  //             to={path}
  //             className="text-base font-semibold leading-6 text-gray-900"
  //           >
  //             {name}
  //           </NavLink>
  //         ))}
  //       </Popover.Group>
  //     </nav>
  //     <Dialog
  //       as="div"
  //       className="lg:hidden"
  //       open={mobileMenuOpen}
  //       onClose={setMobileMenuOpen}
  //     >
  //       <div className="fixed insxet py-3-0 z-10" />
  //       <Dialog.Panel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
  //         <div className="flex items-center justify-between">
  //           <a href="#" className="-m-1.5 p-1.5">
  //             <span className="sr-only">KPSIAJ</span>
  //             <img className="h-16 w-auto" src={kpsiajLogo} alt="kpsiaj-logo" />
  //           </a>
  //           <button
  //             type="button"
  //             className="-m-2.5 rounded-md p-2.5 text-gray-700"
  //             onClick={() => setMobileMenuOpen(false)}
  //           >
  //             <span className="sr-only">Close menu</span>
  //             <XMarkIcon className="h-6 w-6" aria-hidden="true" />
  //           </button>
  //         </div>
  //         <div className="mt-6 flow-root">
  //           <div className="-my-6 divide-y divide-gray-500/10">
  //             <div className="space-y-2 py-6">
  //               {menu.map(({ path, name }, ind) => (
  //                 <NavLink
  //                   key={ind}
  //                   to={path}
  //                   onClick={() => setMobileMenuOpen(false)}
  //                   className="-mx-3 block rounded-lg px-3 py-2 text-lg font-semibold leading-7 text-gray-900 hover:bg-gray-50"
  //                 >
  //                   {name}
  //                 </NavLink>
  //               ))}
  //             </div>
  //           </div>
  //         </div>
  //       </Dialog.Panel>
  //     </Dialog>
  //   </header>
  // );
}
